
















































import Component from 'vue-class-component';
import {Prop, Vue} from 'vue-property-decorator';
import BirdsFurryReport = Orders.BirdsFurryReport;

@Component({
  name: 'BirdsFurryComponent',
})
export default class BirdsFurryComponent extends Vue {
  @Prop({required: true, type: Array})
  reports!: Array<BirdsFurryReport>;

  get birds(): Array<any> {
    if (this.reports != null && this.reports.length > 0)
      return this.reports;
    return [];
  }

  padding(index: number): string {
    if (index > 0) {
      return 'q-pt-lg'
    }
    return '';
  }
}
